module.exports = __webpack_public_path__ + "img/SKMJ_plan2.e25f7f8e.png";